export class FilterChangeEvent {


    public filterGroupKey: string;
    public hasFilters: boolean;
}